import { AfterViewInit, Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-video',
  templateUrl: './dialog-video.component.html',
  styleUrls: ['./dialog-video.component.scss']
})
export class DialogVideoComponent implements AfterViewInit {
  @ViewChild('iframeVideo') iframe!: ElementRef;
  constructor(
    private dialogRef: MatDialogRef<DialogVideoComponent>,
    private render: Renderer2,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngAfterViewInit(): void {
    this.render.setProperty(this.iframe.nativeElement, 'src', this.data.url);
    this.render.setProperty(this.iframe.nativeElement, 'title', this.data.title);
  }
  
  onClose(): void {
    this.dialogRef.close();
  }

}
